export default "__VITE_ASSET__Clc5s4gm__"